export default __webpack_public_path__ + "流.png";